import { useState } from "react";
import { Play } from "lucide-react";
import { track } from "../../analytics/sdk";

export const VIDEO = { id: "IPXiXX2P_9c", title: "Entertainment Nation — Who We Serve", poster: "/images/who-we-serve-video.jpg" };
const CHIPS = ["Corporate", "Country Clubs", "Communities", "Charities", "Private"];

export const HeroVideo = () => {
  const [playing, setPlaying] = useState(false);
  const play = () => { setPlaying(true); track("click", { name: "video_play", label: "who-we-serve-hero" }); };
  return (
    <div data-testid="who-we-serve-hero-video" className="card-enter mx-auto w-full max-w-[600px]">
      <div className="gradient-frame rounded-[22px] p-[2px] shadow-[0_30px_60px_-28px_rgba(0,0,0,0.5)]">
        <div className="relative aspect-video overflow-hidden rounded-[20px] bg-black">
          {playing ? (
            <iframe data-testid="hero-video-iframe" className="absolute inset-0 h-full w-full" src={`https://www.youtube-nocookie.com/embed/${VIDEO.id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`} title={VIDEO.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          ) : (
            <button type="button" onClick={play} data-testid="hero-video-play" aria-label={`Play video: ${VIDEO.title}`} className="group absolute inset-0 h-full w-full">
              <img src={VIDEO.poster} alt="Pacesetters corporate team sharing their Trivia Nation experience at Atlantic Beach Country Club" width="1280" height="720" fetchPriority="high" decoding="sync" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
              <span className="absolute inset-0 bg-black/15 transition-colors group-hover:bg-black/5" />
              <span className="absolute left-1/2 top-1/2 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-en-yellow text-black shadow-[0_0_0_10px_rgba(255,194,14,0.3),0_20px_40px_-10px_rgba(0,0,0,0.5)] transition-transform duration-300 group-hover:scale-110">
                <Play className="ml-1 h-8 w-8" fill="currentColor" />
              </span>
            </button>
          )}
        </div>
      </div>
      <ul aria-label="Audiences we serve" className="mt-4 flex flex-wrap justify-center gap-2">
        {CHIPS.map((c, i) => <li key={c} className="mosaic-chip rounded-full bg-white px-3 py-1 text-xs font-semibold text-black shadow ring-1 ring-black/10" style={{ "--i": i }}>{c}</li>)}
      </ul>
    </div>
  );
};
